import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import Login from './pages/Login';
import VerifyPin from './pages/VerifyPin';
import Dashboard from './pages/Dashboard';
import Subscriptions from './pages/Subscriptions';
import Tenants from './pages/Tenants';
import Roles from './pages/Roles';
import Permissions from './pages/Permissions';
import Users from './pages/Users';
import Reporting from './pages/Reporting';
import KPIs from './pages/KPIs';
import { DataProvider } from './contexts/DataContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <DataProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/verify-pin" element={<VerifyPin />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Dashboard />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/subscriptions" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Subscriptions />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/tenants" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Tenants />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/roles" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Roles />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/permissions" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Permissions />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Users />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/reporting" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <Reporting />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
          <Route path="/kpis" element={
            <ProtectedRoute>
              <Box sx={{ display: 'flex' }}>
                <Layout>
                  <KPIs />
                </Layout>
              </Box>
            </ProtectedRoute>
          } />
        </Routes>
      </DataProvider>
    </AuthProvider>
  );
};

export default App; 